module.exports = __webpack_public_path__ + "static/ranksense_logo-429cad624131af47fd7621fa2073502f.png";